export default class Base {
  replace = (placeholder) => {
    const newNode = this.buildNode(placeholder);

    placeholder.replaceWith(newNode);
  };

  initialize = () => {
    document.querySelectorAll(this.tagName).forEach(this.replace);
  };
}
